import React, { useContext, useEffect } from 'react';
import ActionDropdown from './action-dropdown';
import UserFooter from './user-footer';
import UserInformation from './user-info';
import UserprofileHeader from './user-profile-header';
import { UserProfileContext } from './context';
import { apiService } from 'utils/api';
import { BaseModal } from '@cokitchen/cokitchen-components';

type UserProfileModalProps = {
  show: boolean;
  closeModal: () => void;
  id: string;
};

const UserProfileContent = ({ show, closeModal, id }: UserProfileModalProps) => {
  const { user, setUser } = useContext(UserProfileContext);

  const getUser = async () => {
    const res = await apiService.get(`user/one/${id}`, {
      baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
    });

    setUser(res?.data?.data);
  };

  useEffect(() => {
    if (id) getUser();
  }, [id]);

  return (
    <div>
      {user?.id && (
        <BaseModal position='right' isOpen={show} onRequestClose={closeModal} size='wide' title=''>
          <div className='space-y-6'>
            <ActionDropdown />
            <UserprofileHeader />
            <UserInformation />
            <UserFooter />
          </div>
        </BaseModal>
      )}
    </div>
  );
};

export default UserProfileContent;
